import { pagination_params } from '@/shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = `page=${params.page}&limit=${params.limit}`;

  params.Descripcion &&
    (path = `${path !== '' ? `${path}&` : ''}Descripcion=${params.Descripcion}`);
  return path;
};
